import { MODERATOR_QUESTION, MODERATOR_QUESTION_CATEGORY } from "../mock/URLs";
import { GetQuestionResponse, IQuestionByIdItem, IQuestionCategoryByIdItem } from "../types/question";
import { api } from "./api";

type GetQuestions = {
  params: {
    page: number;
    page_size: number;
    search?: string;
  }
}

export const getQuestions = async ({params}: GetQuestions) => {
  try {
    const {data} = await api.get<GetQuestionResponse>(MODERATOR_QUESTION, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const getQuestionCategory = async () => {
  try {
    const {data} = await api.get(MODERATOR_QUESTION_CATEGORY)
    return data.data
  } catch (e) {
    throw e
  }
}

export const getQuestionCategoryById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: IQuestionCategoryByIdItem }>(`${MODERATOR_QUESTION_CATEGORY}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const createQuestionCategory = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_QUESTION_CATEGORY, formData)
    return data
  } catch (e) {
    throw e
  }
}

export const updateQuestionCategory = async (id, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_QUESTION_CATEGORY}${id}/`, formData)
    return data
  } catch (e) {
    throw e
  }
}

export const createQuestion = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_QUESTION, formData)
    return data
  } catch (e) {
    throw e
  }
}

export const updateQuestion = async (id, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_QUESTION}${id}/`, formData)
    return data
  } catch (e) {
    throw e
  }
}

export const getQuestionById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: IQuestionByIdItem }>(`${MODERATOR_QUESTION}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}